import gql from 'graphql-tag';
import COULD_NOT_COMPLETE_FRAGMENT from '../../../common/graphql/serviceDocket/COULD_NOT_COMPLETE_FRAGMENT';
import { TICKET_LIST_DETAIL_FRAGMENT } from '../../../common/graphql/ticketList';

const DOCKET_DETAIL_NATIVE_FRAGMENT = gql`
	fragment docketDetailNative on ServiceDocket {
		id
		date
		serviceNote

		inventoryCheck
		replacementReviewRequired
		replacementReviewReason
		status
		salesSinceLastRestock
		manualRestock
		isIngredientRestock
		isRestocked
		startedProcessing
		marketRestockCorrectionAvailability {
			allowed
			reason
		}
		ticketsResolved
		inventoryPicked
		inventoryPartiallyPicked
		machineServiceType
		cashBag
		tub
		collectCash
		requirePhoto
		photoTaken
		planned
		hasSomeExpiryDatesToUpdate
		checkedProductExpirySchedules {
			id
		}

		pickList {
			id
			isAnyItemPicked
			hasProductSoldSinceLastPickListRecalculation
		}

		ticketList {
			...ticketList
		}

		productExpiryCheckSchedules {
			id
		}

		machine {
			id
			assetId
			type
			place {
				id
				name
				destroyed
				directions
				visualDirectionPhotos {
					id
					link
					comment
				}
				visualDirectionPhotoUrls
			}
			machineKey {
				id
				name
			}
			hasCoinMech
			coinMech {
				id
				settings
			}
			overrideCoinLimits
			coinLimits
			lastCommunication
			receivedCommunicationTypes
			commDevices {
				id
				deviceId
			}
			usesIngredients
			location {
				id
				addressObj {
					id
					region
					street
					city
					postcode
				}
				name
				accessHours
				requiresSignIn
				signInInstructions
				directions
				visualDirectionPhotos {
					id
					link
					comment
				}
				visualDirectionPhotoUrls
				coordinates

				noteCount
				importantNotes {
					id
					description
				}
			}
			temperatureCelcius
			accessHours
			directions
			coordinates
			noteCount
			importantNotes {
				id
				description
			}

			useLocationCoordinates

			coinMechDetail {
				tubesValueTotal
				tubesDetail {
					coinTypeNumber
					valueCoinsInTube
					numberCoinsInTube
					numberCoinsInsertedManually
					numberCoinsDispensedManually
					tubeIsFull
				}
			}
			wrap {
				name
			}

		}
		serviceRun {
			id
			isOneCashBag
			planned
			vehicle {
				id
				name
				registration
			}
			vehicleConfirmed
			driver {
				id
				firstname
				lastname
			}
		}
	}
	${TICKET_LIST_DETAIL_FRAGMENT}
`;

export const GET_SERVICE_DOCKET_NATIVE = gql`
	query($id: String) {
		getServiceDocket(id: $id) {
			...docketDetailNative
		}
	}
	${DOCKET_DETAIL_NATIVE_FRAGMENT}
`;

export const SUBSCRIBE_TO_SERVICE_DOCKET_NATIVE = gql`
	subscription ($input: ServiceDocketSubscriptionInput!) {
		ServiceDocketSubscription(input: $input) {
			servicedocket {
				...docketDetailNative
			}
		}
	}
	${DOCKET_DETAIL_NATIVE_FRAGMENT}
`;

export const MODIFY_SERVICE_DOCKET = gql`
	mutation modifyServiceDocketMutation($input: ModifyServiceDocketInput!) {
		modifyServiceDocket(input: $input) {
			servicedocket {
				...docketDetailNative
			}
		}
	}
	${DOCKET_DETAIL_NATIVE_FRAGMENT}
`;

// Stop details the driver-day stop fragment does not carry, as on the classic
// stop screen: expiry checks, market restock correction, the run's cash bag
// mode and vehicle (vehicle assignment prompt).
export const GET_STOP_EXTRAS = gql`
	query getStopExtras($id: String) {
		getServiceDocket(id: $id) {
			id
			hasSomeExpiryDatesToUpdate
			productExpiryCheckSchedules {
				id
			}
			checkedProductExpirySchedules {
				id
			}
			marketRestockCorrectionAvailability {
				allowed
				reason
			}
			serviceRun {
				id
				planned
				isOneCashBag
				vehicleConfirmed
				vehicle {
					id
					name
					registration
				}
				driver {
					id
					firstname
					lastname
				}
			}
		}
	}
`;

// "Couldn't complete this machine" on the driver's stop screen, and its Undo.
export const MARK_SERVICE_DOCKET_COULD_NOT_COMPLETE = gql`
	mutation markServiceDocketCouldNotComplete($serviceDocketId: ID!, $reason: String!) {
		markServiceDocketCouldNotComplete(serviceDocketId: $serviceDocketId, reason: $reason) {
			id
			...stopCouldNotComplete
		}
	}
	${COULD_NOT_COMPLETE_FRAGMENT}
`;

export const CLEAR_SERVICE_DOCKET_COULD_NOT_COMPLETE = gql`
	mutation clearServiceDocketCouldNotComplete($serviceDocketId: ID!) {
		clearServiceDocketCouldNotComplete(serviceDocketId: $serviceDocketId) {
			id
			...stopCouldNotComplete
		}
	}
	${COULD_NOT_COMPLETE_FRAGMENT}
`;

export const SERVICE_NOTE_DOCKET_FRAGMENT = gql`
	fragment serviceNoteDocket on ServiceDocket {
		status
		id
		serviceNote
		couldNotComplete { at }
		machine {
			id
			assetId
			location { id name }
		}
		serviceRun {
			id
			driver { id }
			serviceDockets { id status }
		}
	}
`;

export const GET_SERVICE_NOTE_DOCKET = gql`
	query getServiceNoteDocket($id: String) {
		getServiceDocket(id: $id) { ...serviceNoteDocket }
	}
	${SERVICE_NOTE_DOCKET_FRAGMENT}
`;

export const SET_SERVICE_DOCKET_SERVICE_NOTE = gql`
	mutation setServiceDocketServiceNote($id: ID!, $note: String!) {
		setServiceDocketServiceNote(id: $id, note: $note) {
			id
			serviceNote
		}
	}
`;
